
import $ from 'jquery';
import Vue from 'vue';
import { Component, Inject } from 'vue-property-decorator';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { PqtArchiveRequest, PqtProduct } from '../../backend/backendapi';
import { productNumber } from '../util';
import { RiskOption } from './archivemodal.model';
import State from '../State';

@Component({
  components: {
    vSelect,
  },
})
export default class ArchiveModal extends Vue {
  @Inject({ from: 'state' })
  readonly state!: State;

  //runtime
  product: PqtProduct | null = null;
  reason: string = '';
  riskOption: RiskOption | null = null;

  public open(product: PqtProduct): void {
    this.product = product;
    this.reason = '';
    this.riskOption = this.riskOptions[0];
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  archive(): void {
    if (!this.product || !this.riskOption) {
      return;
    }
    this.$emit('archive', new PqtArchiveRequest({ id: this.product.id, reason: this.reason, risk: this.riskOption.id }));
  }

  //getter
  get productNumber(): string {
    if (!this.product) {
      return '';
    }
    return productNumber(this.product, this.state.groupsStore.groupTypes);
  }

  get riskOptions(): RiskOption[] {
    let localRiskOptions = this.state.riskOptionsSetting[this.$i18n.locale] as RiskOption[];
    localRiskOptions ??= this.state.riskOptionsSetting['en'] as RiskOption[];
    return localRiskOptions ?? [{ id: 'none', name: 'none' }];
  }
}
